import queryString from "query-string";
import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ICommentChild, ICommentParent } from "../../store/types/deal";
import { JSON_to_URLEncoded } from "../../utils";

export interface IUseCommentsUrlHooks {
  commentId: number;
  highlightId: number;
  replyId: number;
  commentBelongTo?: string;
  dropCommentFromUrl: () => void;
  setCommentToUrl: (comment: ICommentParent | ICommentChild) => void;
  setSurveyCommentToUrl: (comment: ICommentParent | ICommentChild) => void;
}

export function useCommentsUrlHooks(): IUseCommentsUrlHooks {
  const { replace } = useHistory();
  const { search } = useLocation();

  const queryParams = useMemo(() => {
    return queryString.parse(search);
  }, [search]);

  const commentId: number = useMemo(() => {
    return Number(queryParams?.["comment"]);
  }, [queryParams]);

  const highlightId: number = useMemo(() => {
    return Number(queryParams?.["highlight"]);
  }, [queryParams]);

  const replyId: number | undefined = useMemo(() => {
    return Number(queryParams?.["reply"]);
  }, [queryParams]);

  const commentBelongTo: string | undefined = useMemo(() => {
    return queryParams?.["question-uuid"]?.toString();
  }, [queryParams]);

  const dropCommentFromUrl = (): void => {
    console.log("REMOVE COMMENT");
    if (!commentId) {
      return;
    }
    const search = { ...queryParams };
    delete search["comment"];
    delete search["reply"];
    delete search["question-uuid"];
    replace({
      search: JSON_to_URLEncoded(search),
    });
  };

  const setSurveyCommentToUrl = (
    comment: ICommentParent | ICommentChild
  ): void => {
    const search = { ...queryParams };
    // invalidate comment from the url
    delete search["comment"];
    delete search["reply"];
    delete search["question-uuid"];
    if (comment.parent_id) {
      if (comment.id) {
        search["reply"] = comment?.id?.toString();
      }
      if (comment.parent_id) {
        search["comment"] = comment?.parent_id?.toString();
        search["highlight"] = comment?.id?.toString();
      }
    } else {
      if (comment.id) {
        search["comment"] = comment?.id?.toString();
        search["highlight"] = comment?.id?.toString();
      }
    }
    replace({
      search: JSON_to_URLEncoded(search),
    });
  };

  const setCommentToUrl = (comment: ICommentParent | ICommentChild): void => {
    const search = { ...queryParams };
    // invalidate comment from the url
    delete search["comment"];
    delete search["reply"];
    delete search["question-uuid"];
    if (comment.parent_id) {
      if (comment.id) {
        search["reply"] = comment?.id?.toString();
      }
      if (comment.parent_id) {
        search["comment"] = comment?.parent_id?.toString();
      }
    } else {
      if (comment.id) {
        search["comment"] = comment?.id?.toString();
      }
    }
    if (comment?.question_id?.question_uuid) {
      search["question-uuid"] = comment?.question_id?.question_uuid;
    }
    if (queryParams["bar"] !== "comments") {
      search["bar"] = "comments";
    }
    replace({
      search: JSON_to_URLEncoded(search),
    });
  };

  return {
    commentId,
    replyId,
    highlightId,
    commentBelongTo,
    dropCommentFromUrl,
    setCommentToUrl,
    setSurveyCommentToUrl,
  };
}
